module.exports = __webpack_public_path__ + "static/media/02․05.56fc6703.webp";